import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RequestsServices } from './requests.service';
import { UserService } from './user.service';
import { from } from 'rxjs';

@Injectable()
export class EstablishmentsService {
  userLevel = '';

  constructor(
    public request: RequestsServices,
    public userService: UserService
  ) {
    this.userLevel = this.userService.getUserLevel();
  }

  getEstablishmentInfo(establishmentId, params = {}): Promise<any> {
    return this.request.get({path: 'establishments', params, endPoint: `/${establishmentId}`});
  }

  searchOnlineByName(urlParams): Observable<any> {
    urlParams = this.isMaster(urlParams);
    return from(this.request.get({path: 'establishments', params: urlParams, endPoint: `/searchOnlineByName`}));
  }

  searchByName(urlParams): Observable<any> {
    urlParams = this.isMaster(urlParams);
    return from(this.request.get({path: 'establishments', params: urlParams, endPoint: `/searchByName`}));
  }

  exploreLocation(urlParams): Observable<any> {
    urlParams = this.isMaster(urlParams);
    return from(this.request.get({path: 'establishments', params: urlParams, endPoint: `/exploreLocation`}));
  }

  removeEstablishment(id): Observable<any> {
    return from(this.request.delete('establishments', '', `/${id}`));
  }

  getFavoriteEstablishment(establishmentId): Promise<any> {
    return this.request.get({path: 'establishment_favorites', endPoint: `/${establishmentId}`});
  }

  favoriteEstablishment(establishmentId): Promise<any> {
    return this.request.post('establishment_favorites', { establishmentId });
  }

  unfavoriteEstablishment(establishmentId): Promise<any> {
    return this.request.delete('establishment_favorites', '', `/${establishmentId}`);
  }

  getEstablishmentAddresses(id, location) {
    return from(this.request.get({path: 'establishments', params: {location}, endPoint: `/${id}/addresses`}));
  }

  isMaster = (params) => {
    return this.userLevel === 'master' ?  { show_hidden_partnerships: true, ...params } : params;
  }

  completeUrlWithAnalyticsParameters(campaignName, campaignLink): Observable<any> {
    return from(this.request.post('establishments', { campaignLink, campaignName }, '/completeUrlWithAnalyticsParameters'));
  }
}
